import React from 'react';
import { enabledFlippers } from '../../../src/web/components/sections/manifest';
import AdminNavbar from '../../../src/admin/layout/components/AdminNavbar';
import { PAGE_LAYOUT } from '../../../src/shared/pageTypes';
import ComponentLibrary from '../../../src/admin/modules/pageBuilder/components/ComponentLibrary';
import { FLIPPER_ENTERPRISE_OPTIONS } from '../../../constants/flippers';
import useFlipper from '../../../modules/react/hooks/useFlipper';
import useLayoutEditor from '../../hooks/useLayoutEditor';

const PageLayoutEditAdminNavbar = () => {
  const [
    state,
    {
      onToggleComponentLibrary,
      onSectionStartDragging,
      onSectionStopDragging,
      onWidgetStartDragging,
      onWidgetStopDragging,
    },
  ] = useLayoutEditor();

  const isEnterprise = useFlipper(FLIPPER_ENTERPRISE_OPTIONS);

  const flippers = enabledFlippers.reduce((acc, flipper) => (
    { ...acc, [flipper]: useFlipper(flipper) }
  ), {});

  const { showComponentLibrary } = state;

  const add = {
    text: 'Add Section / Widget',
    onClick: onToggleComponentLibrary,
    authorization: null,
    active: showComponentLibrary,
  };

  const panel = (
    <ComponentLibrary
      pageType={PAGE_LAYOUT}
      show={showComponentLibrary}
      onSectionStartDragging={onSectionStartDragging}
      onSectionStopDragging={onSectionStopDragging}
      onWidgetStartDragging={onWidgetStartDragging}
      onWidgetStopDragging={onWidgetStopDragging}
      onToggleComponentLibrary={onToggleComponentLibrary}
      accessEnterpriseOptions={isEnterprise}
      // hiding the addons for the new layout editor because ComponentLibrary
      // relies on presentPagehaving keys from the `pageBuilder` redux store
      // and this component is not hooked up to the store
      hideAddOns
      {...flippers}
    />
  );

  return (
    <AdminNavbar
      add={add}
      panel={panel}
    />
  );
};

export default PageLayoutEditAdminNavbar;
